module.exports = __webpack_public_path__ + "img/logo_wanderergraphic.89fe8f1a.png";